import gql from 'graphql-tag';

export const CAMPAIGNS_QUERY = gql`
  query ArticleGroupCampaignQuery($id: ID!) {
    articleGroup(id: $id) {
      articles {
        campaign {
          id
          name
        }
      }
    }
  }
`;
